import { Button, Card, CardGroup, Col, Row, Spinner } from "react-bootstrap";
import { useActivateUserMutation } from "../backend/hooks/mutationActivateUser";
import { useUserHelper } from "../hooks/userHelper";
import video_externals from "../resources/PHILtraining_externals.webm";
import training_slides from "../resources/TrainingExternals.pdf";
import training_material from "../resources/training_material.png";
import Error from "./abstractComponents/error";
import { useAuth } from "./authContextProvider";

// Landing page for a user that has not performed the PHIL training
export default function External() {
  const { signOut } = useAuth();
  const { isUnactivatedUser } = useUserHelper();
  const { activateUserMutation, isLoadingMutation, errorMutation } =
    useActivateUserMutation();

  function activateUser() {
    if (
      window.confirm(
        "Please confirm that you have completed all of the trainings by clicking on OK!\nAfter clicking on it, you will be logged out and redirected to the login page. To finalize the confirmation and registration procedure, please log in again!"
      )
    ) {
      activateUserMutation().then(() => {
        signOut();
      });
    }
  }

  return (
    <div className="app_content">
      {isLoadingMutation && (
        <div className="center_div">
          <Spinner animation="border" className="spinner_color" />
          <p>Loading...</p>
        </div>
      )}
      {!isLoadingMutation && !errorMutation && (
        <div>
          <h3>Welcome to the PHIL training page!</h3>
          <Row className="mb-5">
            <Col xs={6}>
              <p>Please follow the instructions below to get access to PHIL</p>
              <ol className="text-color-light fs-7">
                <li>
                  Read the training slides. Additionally, you are free to watch
                  the training video for a better comprehension of PHIL.
                </li>
                <li>
                  Confirm that you have conducted and understood the training
                  slides.
                </li>
                <li>
                  After pressing the confirmation button, you will be redirected
                  to the PHIL login page. Re-login into PHIL in order to
                  successfully complete the training confirmation.
                </li>
                <li>
                  Inform your Bayer partner that you have completed the
                  training.
                </li>
              </ol>
            </Col>
          </Row>
          <CardGroup>
            <Card className="me-3">
              <video
                controls
                src={video_externals}
                title="Training Video"
              ></video>
              <Card.Body>
                <Card.Title>PHIL Training Video</Card.Title>
                <Card.Text className="text-color-light fs-7">
                  The training video serves as a supplement to the training
                  slides. It is recommended to watch it in addition to the
                  slides.
                </Card.Text>
              </Card.Body>
            </Card>

            <Card className="ms-3 border-start">
              <Card.Img
                variant="top"
                src={training_material}
                alt="training_material"
              />
              <Card.Body>
                <Card.Title>PHIL Training Slides </Card.Title>
                <Card.Text className="text-color-light fs-7">
                  The training slides contain the most important information
                  about PHIL as well as short explanations of its
                  functionalities.
                </Card.Text>
                <div className="center_div">
                  <Button
                    href={training_slides}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read Training Slides
                  </Button>
                </div>
                {isUnactivatedUser && (
                  <div className="center_div">
                    <Button className="confirm_training" onClick={activateUser}>
                      Confirm Training
                    </Button>
                  </div>
                )}
                {errorMutation && <Error error={errorMutation} />}
              </Card.Body>
            </Card>
          </CardGroup>
          <br />
        </div>
      )}
    </div>
  );
}
